import { useRef } from "react";
import { motion, useInView } from "framer-motion";

/**
 * Reveal an image via clip-path (bottom → top).
 * The in-view sensor is the outer (unclipped) wrapper, otherwise the
 * fully-clipped element never intersects and stays hidden forever.
 */
export default function ClipImage({ src, alt = "", className = "", grayscale = false }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.05 });
  const pos = /\babsolute\b/.test(className) ? "absolute" : "relative";
  return (
    <div ref={ref} style={{ position: pos }} className={`overflow-hidden ${className}`}>
      <motion.div
        className="absolute inset-0"
        initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
        animate={inView ? { clipPath: "inset(0% 0% 0% 0%)" } : undefined}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className={`w-full h-full object-cover ${grayscale ? "grayscale hover:grayscale-0 transition-all duration-1000" : ""}`}
        />
      </motion.div>
    </div>
  );
}
